import Global from './global/global.js';

class DonorApplicationManagementMicrobiomeInformationClauseView extends Global {

    constructor() {
        super();
    }
}

new DonorApplicationManagementMicrobiomeInformationClauseView();